import React from 'react';
import styled from 'styled-components';
import { Mode, SelectableButton } from '@components/ringil3/Buttons/SelectableButton';

interface ComponentProps {
  model: ClickableItem[];
  selectedItemCodes: string[];
  onSelect: (selectedItemCodes: string[]) => void;
  disabled?: boolean;
  /** Paints the unselected options yellow while nothing is selected, the same signal Field gives a required input. */
  mandatory?: boolean;
  dataTestIdPrefix?: string;
}

interface ClickableItem {
  code: string;
  label: string;
}

const InputSelect: React.FC<ComponentProps> = ({ model, selectedItemCodes = [], onSelect, disabled = false, mandatory = false, dataTestIdPrefix }) => {
  const isSelected = (code: string): boolean => {
    return selectedItemCodes?.find(item => item === code) !== undefined;
  };

  const toggleValue = (code: string): void => {
    if (isSelected(code)) {
      onSelect(selectedItemCodes.filter(item => item !== code));
    } else {
      onSelect([...selectedItemCodes, code]);
    }
  };

  return (
    <>
      <InputSelectInner>
        {model.map((item, itemPos) => {
          return <SelectableButton
            key={itemPos}
            label={item.label}
            mode={disabled ? Mode.Disabled : isSelected(item.code) ? Mode.Checked : mandatory && selectedItemCodes?.length === 0 ? Mode.Required : Mode.Active}
            onClick={() => !disabled && toggleValue(item.code)}
            checked={isSelected(item.code)}
            dataTestId={dataTestIdPrefix ? `${dataTestIdPrefix}-${item.code.toLowerCase()}` : undefined}
          />;
        })}
      </InputSelectInner>
    </>
  );
};

const InputSelectInner = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export default InputSelect;
